// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Tasks = function Tasks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tasks-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.008 2.816a.935.935 0 0 0-.07-1.324.935.935 0 0 0-1.325.07L2.465 3.95l-.863-.863a.945.945 0 0 0-1.329 0 .934.934 0 0 0 0 1.324l1.563 1.563a.937.937 0 0 0 1.36-.035l2.812-3.126zm0 6.25a.935.935 0 0 0-.07-1.324.935.935 0 0 0-1.325.07L2.465 10.2l-.863-.863A.937.937 0 0 0 .278 10.66l1.562 1.563a.937.937 0 0 0 1.36-.035l2.812-3.126zm2.43-4.379h10.625c.519 0 .937-.418.937-.937a.935.935 0 0 0-.937-.938H8.438a.935.935 0 0 0-.938.938c0 .52.418.937.938.937M7.5 10c0 .52.418.937.938.937h10.625c.519 0 .937-.418.937-.937a.935.935 0 0 0-.937-.938H8.438A.935.935 0 0 0 7.5 10m-1.25 6.25c0 .52.418.937.938.937h11.875c.519 0 .937-.418.937-.937a.935.935 0 0 0-.937-.938H7.188a.935.935 0 0 0-.938.938m-2.5 0a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tasks-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};
